import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import AffiliateAutomationTable from '@/components/v2/AffiliateAutomationTable.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let AffiliateAutomation = class AffiliateAutomation extends Mixins(ViewportSizeMixin, CleverTapEventsMixin) {
    automationRouteSelect() {
        if (this.$route.params.key === 'affiliate-bundle') {
            return { name: 'add-automation' };
        }
        return { name: 'ecommerce-add-automation' };
    }
    mounted() {
        this.viewAutomationPage();
    }
};
__decorate([
    Prop({ type: String, required: true })
], AffiliateAutomation.prototype, "appUUID", void 0);
AffiliateAutomation = __decorate([
    Component({
        components: {
            PageTitle,
            ActionButton,
            AffiliateAutomationTable,
        },
    })
], AffiliateAutomation);
export default AffiliateAutomation;
